
// Definición de defaults

export const defaultTipoPersona: TipoPersonaProps = {
    idTipoPersona:  0,
    descripcion:    '',
    activo:         false
};

// Creación de interfaces

export interface TipoPersonaProps{
    idTipoPersona:  number;
    descripcion:    string;
    activo:         boolean;
}
